import { CardContent, TextField, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { CornermarkErrorFragment } from "@saleor/fragments/types/CornermarkErrorFragment";
import { commonMessages } from "@saleor/intl";
import { CornerMarkTypeEnum } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import getCornermarkErrorMessage from "@saleor/utils/errors/cornermark";
import React from "react";
import { useIntl } from "react-intl";

import { CornermarkPageFormData } from "../CornermarkPage/CornermarkPage";

export interface CornermarkDetailsProps {
  data: CornermarkPageFormData;
  disabled: boolean;
  errors: CornermarkErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  title: string;
}
const CornermarkDetails: React.FC<CornermarkDetailsProps> = ({
  data,
  disabled,
  errors,
  onChange
}) => {
  const intl = useIntl();

  const TypeChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "Normal",
        description: "product variant cornermark type"
      }),
      value: CornerMarkTypeEnum.NORMAL
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Pre Order",
        description: "product variant cornermark type"
      }),
      value: CornerMarkTypeEnum.PRE_ORDER
    },
    {
      label: intl.formatMessage({
        defaultMessage: "Sold Out",
        description: "product variant cornermark type"
      }),
      value: CornerMarkTypeEnum.SOLD_OUT
    }
  ];

  const formErrors = getFormErrors(
    ["title", "textColor", "code", "mainColor", "secondaryColor", "type"],
    errors
  );
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Text Of Cornermark",
            description: "the title text of the cornermark"
          })}
          error={!!formErrors.title}
          name={"title" as keyof CornermarkPageFormData}
          fullWidth
          helperText={getCornermarkErrorMessage(formErrors.title, intl)}
          value={data.title}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.textColor}
          label={intl.formatMessage({
            defaultMessage: "Text Color",
            description: "the color for title text"
          })}
          name={"textColor" as keyof CornermarkPageFormData}
          fullWidth
          helperText={
            getCornermarkErrorMessage(formErrors.textColor, intl) ||
            intl.formatMessage({
              defaultMessage:
                "This is used to the text displayed in cornermark. Please use color RGB values, e.g. #0000FF",
              description: "cornermark text color input field helper text"
            })
          }
          value={data.textColor}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Main Color",
            description: "the main color for cornermark"
          })}
          error={!!formErrors.mainColor}
          name={"mainColor" as keyof CornermarkPageFormData}
          fullWidth
          helperText={getCornermarkErrorMessage(formErrors.mainColor, intl)}
          value={data.mainColor}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Secondary Color",
            description: "the secondary color for cornermark"
          })}
          error={!!formErrors.secondaryColor}
          name={"secondaryColor" as keyof CornermarkPageFormData}
          fullWidth
          helperText={getCornermarkErrorMessage(
            formErrors.secondaryColor,
            intl
          )}
          value={data.secondaryColor}
          onChange={onChange}
        />
        <FormSpacer />
        <SingleSelectField
          disabled={disabled}
          choices={TypeChoices}
          error={!!formErrors.type}
          hint={getCornermarkErrorMessage(formErrors.type, intl)}
          label={intl.formatMessage({
            defaultMessage: "Display Type",
            description: "Cornermark's Display Type"
          })}
          name="type"
          onChange={onChange}
          value={data.type}
        />
        <FormSpacer />
        <Typography color="primary">Cornermark results the preview</Typography>
        <FormSpacer />
        {data.title ? (
          data?.secondaryColor ? (
            <div
              style={{
                background: ` linear-gradient(to right, ${data.mainColor} 0%,${data.secondaryColor} 100%)`,
                width: "120px",
                height: "30px",
                textAlign: "center"
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "30px",
                  color: data.textColor,
                  textAlign: "center"
                }}
              >
                {data.title}
              </p>
            </div>
          ) : (
            <div
              style={{
                background: data.mainColor,
                width: "120px",
                height: "30px",
                textAlign: "center"
              }}
            >
              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "30px",
                  color: data.textColor,
                  textAlign: "center"
                }}
              >
                {data.title}
              </p>
            </div>
          )
        ) : (
          <p>After the save</p>
        )}
      </CardContent>
    </Card>
  );
};
export default CornermarkDetails;
